import React from 'react';
import { Modal } from './Modal';

interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  children?: React.ReactNode;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  children,
}) => (
  <Modal isOpen={isOpen} title={title} onClose={onCancel}>
    <p className="mb-4 text-gray-700">{message}</p>
    {children}
    <div className="flex justify-end gap-2">
      <button
        className="bg-gray-200 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-300"
        onClick={onCancel}
      >
        {cancelText}
      </button>
      <button
        className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700"
        onClick={onConfirm}
      >
        {confirmText}
      </button>
    </div>
  </Modal>
);
